import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWalletEmptyWallet = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	overflow: "visible",
	style: { display: "block" },
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "empty-wallet",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Vector",
				d: "M5.21712 6.33333H14.7835C16.5823 6.33344 18.0413 7.79333 18.0413 9.59212V10.7913C18.0413 10.8215 18.0289 10.8536 18.0033 10.8792C17.9777 10.9045 17.9463 10.9163 17.9163 10.9163H16.2337C15.8197 10.9163 15.4216 11.0705 15.1292 11.3714L15.1214 11.3802C14.7796 11.7137 14.6237 12.1677 14.6595 12.6224L14.6605 12.6283C14.7371 13.4706 15.5112 14.0745 16.3333 14.0745H17.9163C17.9463 14.0745 17.9777 14.0872 18.0033 14.1126C18.0288 14.1381 18.0412 14.1695 18.0413 14.1995V15.1917C18.0413 16.9995 16.5815 18.4582 14.7835 18.4583H5.21712C3.41827 18.4583 1.95833 16.9984 1.95833 15.1995V9.59212C1.95833 7.79326 3.41827 6.33333 5.21712 6.33333ZM5.21712 6.58333C3.55764 6.58333 2.20833 7.93265 2.20833 9.59212V15.1995C2.20833 16.859 3.55764 18.2083 5.21712 18.2083H14.7835C16.4429 18.2082 17.7913 16.859 17.7913 15.1995V14.3333H16.3333C15.3138 14.3333 14.4833 13.5787 14.4066 12.6585L14.4056 12.6517L14.3978 12.4535C14.4055 11.993 14.5967 11.5466 14.9427 11.2064L14.9486 11.2005C15.2861 10.8565 15.7405 10.6663 16.2337 10.6663H17.7913V9.59212C17.7913 7.93271 16.4429 6.58344 14.7835 6.58333H5.21712Z",
				fill: "#3C3C3C",
				stroke: "#3C3C3C"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_2",
				d: "M2.08333 10.9667C1.74167 10.9667 1.45833 10.6833 1.45833 10.3417V6.53338C1.45833 5.29172 2.24167 4.16667 3.4 3.725L10.0167 1.225C10.7 0.966671 11.4583 1.05838 12.05 1.47505C12.65 1.89171 13 2.56671 13 3.29171V6.45836C13 6.80003 12.7167 7.08336 12.375 7.08336C12.0333 7.08336 11.75 6.80003 11.75 6.45836V3.29171C11.75 2.97504 11.6 2.68336 11.3333 2.50003C11.0667 2.3167 10.75 2.27502 10.45 2.39169L3.83333 4.89169C3.15833 5.15002 2.7 5.80838 2.7 6.53338V10.3417C2.70833 10.6917 2.425 10.9667 2.08333 10.9667Z",
				fill: "#3C3C3C"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_3",
				d: "M16.3333 14.8333C15.075 14.8333 14.0083 13.8999 13.9083 12.6999C13.8416 12.0083 14.0916 11.3333 14.5916 10.8416C15.0166 10.4083 15.6 10.1666 16.225 10.1666H17.9583C18.7833 10.1916 19.4166 10.8416 19.4166 11.6416V13.3583C19.4166 14.1583 18.7833 14.8083 17.9833 14.8333H16.3333ZM17.9416 11.4166H16.2333C15.9416 11.4166 15.675 11.525 15.4833 11.725C15.2416 11.9583 15.125 12.2749 15.1583 12.5916C15.2083 13.1416 15.7333 13.5833 16.3333 13.5833H17.9666C18.075 13.5833 18.175 13.4833 18.175 13.3583V11.6416C18.175 11.5166 18.075 11.425 17.9416 11.4166Z",
				fill: "#3C3C3C"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_4",
				d: "M11.6667 10.625H5.83333C5.49167 10.625 5.20833 10.3417 5.20833 10C5.20833 9.65833 5.49167 9.375 5.83333 9.375H11.6667C12.0083 9.375 12.2917 9.65833 12.2917 10C12.2917 10.3417 12.0083 10.625 11.6667 10.625Z",
				fill: "#3C3C3C"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_5",
				opacity: 0,
				d: "M20 0H0V20H20V0Z",
				fill: "#3C3C3C"
			})
		]
	})
});
export default SvgWalletEmptyWallet;
